import { takeEvery } from 'redux-saga/effects';
import { types } from '../actions.js';
import fetchMarkdown from './fetchMarkdown.js';
import fetchJson from './fetchJson.js';

var takes = [takeEvery(types.FETCH_MARKDOWN, fetchMarkdown), takeEvery(types.FETCH_JSON, fetchJson)];
var sagas = {
  fetchMarkdown: fetchMarkdown,
  fetchJson: fetchJson
};
var sagas$1 = sagas;

export { sagas$1 as default, takes };
//# sourceMappingURL=index.js.map
